<template>
  <div>
    <v-dialog v-model="value" persistent :max-width="maxW" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-image-input
                  ref="imageEditer"
                  fullHeight
                  fullWidth
                  :imageHeight="height"
                  :imageWidth="width"
                  v-model="imageData"
                  :image-quality="1"
                  clearable
                  image-format="jpeg"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel">
            {{ $t('generic.cancel') }}
          </v-btn>
          <v-btn color="primary darken-1" flat @click="save">
            {{ $t('generic.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <alert
      v-model="alert.flag"
      :title="alert.title"
      :description="alert.description"
    ></alert>
  </div>
</template>

<script>
import VImageInput from 'vuetify-image-input'
import alert from '../Dialogs/Alert'
export default {
  components: {
    [VImageInput.name]: VImageInput,
    alert,
  },
  props: ['value', 'height', 'width', 'maxWidth', 'image', 'title'],
  data: () => ({
    imageData: '',
    alert: {
      title: '',
      description: '',
      flag: false,
    },
    maxW: '600px',
  }),
  watch: {
    value() {
      if (this.value) {
        this.imageData = this.image
          ? 'data:image/jpeg;base64,' + this.image
          : ''
      }
      if (this.maxWidth) {
        this.maxW = this.maxWidth
      }
    },
  },
  methods: {
    save() {
      if (this.imageData != null && this.imageData != '') {
        this.$emit('loaded', this.imageData)
        this.$emit('input', !this.value)
        this.imageData = ''
        this.$refs.imageEditer.clear()
      } else {
        this.alert.title = 'Error'
        this.alert.description = 'Debes de seleccionar al menos una imagen'
        this.alert.flag = true
      }
    },
    cancel() {
      this.$refs.imageEditer.clear()
      this.imageData = ''
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style>
.half {
  height: 50vh;
}
</style>
